import {
  Address,
  BasicPointOfService,
  KycStatus,
  OpeningDay,
  OpeningDaysHistory,
  PointOfService,
  PosType,
} from 'types';
import { convertTimestampToDate } from 'helpers';

function populateAddressData(addressData: any = {}): Address {
  const { region, country } = addressData;

  return {
    phone1: addressData?.phone || '',
    phone2: addressData?.phone2 || '',
    town: addressData?.town || '',
    streetName: addressData?.streetName || '',
    streetNumber: addressData?.streetNumber || '',
    complement: addressData?.complement || '',
    district: addressData?.district || '',
    postalCode: addressData?.postalCode || '',
    receiverFirstName: addressData?.receiverFirstName || '',
    receiverLastName: addressData?.receiverLastName || '',
    region: {
      isoCode: region?.isocode || '',
      name: region?.name || '',
    },
    country: {
      isoCode: country?.isocode || '',
      name: country?.name || '',
    },
  };
}

function populateNotificationEmail(notificationEmailData: any = []): string[] {
  return notificationEmailData.map((notificationEmail: any) => {
    return notificationEmail || '';
  });
}

function populateOpeningDays(openingDaysData: any = []): OpeningDay[] {
  return openingDaysData.map((openingDay: any) => {
    const { closingTime, open, openingTime, weekday } = openingDay;

    return {
      closingTime: closingTime || 0,
      open: open || false,
      openingTime: openingTime || 0,
      weekday: weekday || '',
    };
  });
}

type HistoryEntry = {
  newDate: Date;
  oldDate: Date;
  type: string;
};

function populateEntries(entriesData: any = []): HistoryEntry[] {
  return entriesData.map((entryData: any) => {
    const { newDate, oldDate, type } = entryData;

    return {
      newDate: newDate || 0,
      oldDate: oldDate || 0,
      type: type || '',
    };
  });
}

export function openingDaysHistoryFactory(
  params: any = []
): OpeningDaysHistory[] {
  return params.map((openingDaysHistoryData: any) => {
    const { changeBy, weekday, date, entries } = openingDaysHistoryData;

    return {
      changeBy: changeBy || '',
      weekday: weekday || '',
      date: convertTimestampToDate(date || 0),
      entries: populateEntries(entries),
    };
  });
}

export function basicPointOfServiceFactory(
  params: any = {}
): BasicPointOfService {
  const { name } = params;

  return {
    name: name || '',
  };
}

export function pointOfServiceFactory(params: any = {}): PointOfService {
  const {
    name,
    displayName,
    baseStore,
    phone,
    openingHoursMessage,
    discountAllowed,
    posType,
    participateInPickUpStore,
    participateInStoreShipping,
    address,
    notificationEmail,
    geoPoint,
    openingDays,
    openingDaysHistory,
    invoicePointOfSale,
    taxCouponPointOfSale,
    manualPointOfSale,
    exchangeOmniEnable,
    kycStatus,
    bankDocument,
  } = params;

  return {
    name: name || '',
    displayName: displayName || '',
    baseStore: baseStore?.toLowerCase() || '',
    phone: phone || '',
    openingHoursMessage: openingHoursMessage || '',
    discountAllowed: discountAllowed || 0,
    posType: posType || PosType.NA,
    participateInPickUpStore: participateInPickUpStore || false,
    participateInStoreShipping: participateInStoreShipping || false,
    address: populateAddressData(address),
    notificationEmail: populateNotificationEmail(notificationEmail),
    geoPoint: {
      latitude: geoPoint?.latitude || 0,
      longitude: geoPoint?.longitude || 0,
    },
    openingDays: populateOpeningDays(openingDays),
    openingDaysHistory: openingDaysHistoryFactory(openingDaysHistory),
    taxCouponPointOfSale: taxCouponPointOfSale || null,
    invoicePointOfSale: invoicePointOfSale || null,
    manualPointOfSale: manualPointOfSale || null,
    exchangeOmniEnable: exchangeOmniEnable || null,
    kycStatus: kycStatus || KycStatus.Undefined,
    bankDocument: bankDocument || '',
  };
}
